import script from "./base-copy-element.vue?vue&type=script&setup=true&lang=js"
export * from "./base-copy-element.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__